import EnrollmentAcknowledgement from "../../enrollmentAcknowledgement/EnrollmentAcknowledgement";
import { OpenEnrollment } from "../../../../../types/openEnrollment.types";
import { Plan } from "../../../../../types/plan.types";
import { useState, useEffect, useContext, useCallback, useMemo } from "react";
import { PlanAcknowledgementProps } from "../../../../../types/components/enrollmentProps.types";
import { EnrollmentSchema } from "../../../../../types/enrollment.types";
import { AuthContext, ThemeContext } from "../../../../../contexts";
import { Paper, Grid, Button } from "@mui/material";
import { useHistory, useLocation } from "react-router-dom";
import { DISCLAIMER_WAIVED_DESCRIPTION } from "../../../../../constants/disclaimerText";
import { CustomAlertMessage } from "../../../../shared";
import { getEnrollmentInitData } from "../../../../../utils/api/pages/enrollmentInit";

const PlanAcknowledgement = ({
	openEnrollments,
	enrollments,
	planName,
	selectedPlan,
	submittedEnrollment
}: PlanAcknowledgementProps & { submittedEnrollment?: any }): JSX.Element => {
	// console.log(
	// 	"openEnrollments",
	// 	openEnrollments,
	// 	"enrollments",
	// 	enrollments,
	// 	"planName",
	// 	planName,
	// 	"running after ========> 222",
	// 	selectedPlan,
	// 	"submitted",
	// 	submittedEnrollment
	// );
	console.log("submittedEnrollment=====>", submittedEnrollment);
	const [openEnrollment, setOpenEnrollment] = useState<
		OpenEnrollment & {
			plan: Plan;
		}
	>();
	const { theme } = useContext(ThemeContext);
	const [enrollment, setEnrollment] = useState<EnrollmentSchema>();
	const { member } = useContext(AuthContext);
	const location = useLocation();
	const history = useHistory();
	const urlSearchParams: URLSearchParams = useMemo(() => new URLSearchParams(location.search), [location.search]);
	// console.log("akncow enrollments", enrollments);

	const findPlanOpenEnrollment = useCallback(() => {
		for (let openEnrollmentIdx = 0; openEnrollmentIdx < openEnrollments.length; openEnrollmentIdx++) {
			const _openEnrollment = openEnrollments[openEnrollmentIdx].open_enrollment;
			if (_openEnrollment.plan.plan_name === planName) {
				setOpenEnrollment(Object.assign({}, _openEnrollment));
				break;
			}
		}
	}, [openEnrollments, planName]);

	const findPlanEnrollment = useCallback(() => {
		if (!member) {
			return;
		}
		// console.log("found enrollments", enrollments);
		for (let enrollmentIdx = 0; enrollmentIdx < enrollments.length; enrollmentIdx++) {
			const _enrollment = enrollments[enrollmentIdx];
			if (
				_enrollment.member_SSN === member.SSN &&
				_enrollment.insured_SSN === member.SSN &&
				_enrollment.plan?.plan_name === planName
			) {
				// console.log("found enrollment", _enrollment);
				setEnrollment(Object.assign({}, _enrollment));
				break;
			}
		}
	}, [enrollments, member, planName]);

	const handleEnrollAgainButtonClick = useCallback(() => {
		const step = urlSearchParams.get("step");
		history.push(`?step=${step}&stage=1`);
	}, [history, urlSearchParams]);

	// const handleMainRenderingPlanDetails = useCallback(() => {
	// 	if (!selectedPlan && !openEnrollment && !enrollment) {
	// 		return null;
	// 	}
	// 	if(enrollment)
	// }, [openEnrollment,enrollments, selectedPlan]);

	useEffect(() => {
		findPlanOpenEnrollment();
		findPlanEnrollment();
	}, [findPlanEnrollment, findPlanOpenEnrollment, selectedPlan, getEnrollmentInitData]);

	// if (!enrollment) return <></>;
	console.log(openEnrollment, "running after", selectedPlan, "Test", enrollment);
	const finalStatus =
		submittedEnrollment?.[planName]?.enrollment_status ??
		enrollment?.enrollment_status ??
		(selectedPlan?.auto_approve ? "ACTIVE" : "SUBMITTED");

	return (
		<div className="paper-form-container">
			<Paper className="theme-border-radius paper-container" elevation={1}>
				{enrollment && selectedPlan ? (
					<EnrollmentAcknowledgement
						idCardAccessPointRequired={true}
						dependentChangePointRequired={true}
						carrierPhoneNo={"(555) 555-1234"}
						carrierWebsite={"brookshirebrothers.com"}
						planDocument={selectedPlan ? selectedPlan.document : enrollment?.plan.document}
						planName={selectedPlan ? selectedPlan.plan_name : enrollment?.plan.plan_name}
						addDependentLink={"/home/add-family-member"}
						planCode={selectedPlan ? selectedPlan.plan_code : enrollment?.plan.plan_code}
						removeDependentLink={""}
						// status={
						// 	enrollment?.enrollment_status
						// 		? enrollment?.enrollment_status
						// 		: selectedPlan.auto_approve
						// 		? "ACTIVE"
						// 		: "SUBMITTED"
						// }
						status={finalStatus}
					/>
				) : // ) : (location.state as any) && (location.state as any).length > 0 ? (
				// 	<EnrollmentAcknowledgement
				// 		idCardAccessPointRequired={true}
				// 		dependentChangePointRequired={true}
				// 		carrierPhoneNo={"(555) 555-1234"}
				// 		carrierWebsite={"brookshirebrothers.com"}
				// 		planDocument={{ ...(location.state as any)[0]?.plan?.document }}
				// 		planName={(location.state as any)[0]?.plan_name}
				// 		addDependentLink={"/home/add-family-member"}
				// 		planCode={(location.state as any)[0]?.plan_code}
				// 		removeDependentLink={""}
				// 		status={(location.state as any)[0]?.enrollment_status}
				// 	/>
				null}
				{!enrollment && selectedPlan && submittedEnrollment && submittedEnrollment[planName] ? (
					<EnrollmentAcknowledgement
						idCardAccessPointRequired={true}
						dependentChangePointRequired={true}
						carrierPhoneNo={"(555) 555-1234"}
						carrierWebsite={"brookshirebrothers.com"}
						planDocument={selectedPlan.document}
						planName={selectedPlan.plan_name}
						addDependentLink={"/home/add-family-member"}
						planCode={selectedPlan.plan_code}
						removeDependentLink={""}
						// status={submittedEnrollment[planName].enrollment_status}
						status={finalStatus}
					/>
				) : // ) : (location.state as any) && (location.state as any).length > 0 ? (
				// 	<EnrollmentAcknowledgement
				// 		idCardAccessPointRequired={true}
				// 		dependentChangePointRequired={true}
				// 		carrierPhoneNo={"(555) 555-1234"}
				// 		carrierWebsite={"brookshirebrothers.com"}
				// 		planDocument={{ ...(location.state as any)[0]?.plan?.document }}
				// 		planName={(location.state as any)[0]?.plan_name}
				// 		addDependentLink={"/home/add-family-member"}
				// 		planCode={(location.state as any)[0]?.plan_code}
				// 		removeDependentLink={""}
				// 		status={(location.state as any)[0]?.enrollment_status}
				// 	/>
				null}
				<div className="theme-plan-section-margin" />
				{/* {enrollment &&
				["SUBMITTED", "WAIVED", "WAIVED - WAITING FOR APPROVAL"].includes(enrollment?.enrollment_status) ? ( */}
				{["SUBMITTED", "WAIVED", "WAIVED - WAITING FOR APPROVAL"].includes(finalStatus) ? (
					<Grid container>
						<Grid item xl={4} lg={4} xs={12} md={12} sm={12}></Grid>
						<Grid item xl={4} lg={4} xs={12} md={12} sm={12}>
							<Button
								style={{
									backgroundColor: theme.button.background_color,
									color: theme.button.color,
									width: "100%"
								}}
								onClick={handleEnrollAgainButtonClick}
							>
								Enroll again
							</Button>
						</Grid>
						<Grid item xl={4} lg={4} xs={12} md={12} sm={12}></Grid>
					</Grid>
				) : selectedPlan?.auto_approve ? (
					<></>
				) : (
					<Grid container>
						<Grid item xl={4} lg={4} xs={12} md={12} sm={12}></Grid>
						<Grid item xl={4} lg={4} xs={12} md={12} sm={12}>
							<Button
								style={{
									backgroundColor: theme.button.background_color,
									color: theme.button.color,
									width: "100%"
								}}
								onClick={handleEnrollAgainButtonClick}
							>
								Enroll again
							</Button>
						</Grid>
						<Grid item xl={4} lg={4} xs={12} md={12} sm={12}></Grid>
					</Grid>
				)}
			</Paper>
		</div>
	);
};

export default PlanAcknowledgement;
